import { GzRuleContainerWebComponent } from './component/GzRuleContainerWebComponent';

export { GzRuleContainerWebComponent };
